var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#chevron-down',
                        view: publicPath + 'sprite.svg#view-chevron-down',
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };


//////////////////
// WEBPACK FOOTER
// ./src/svg/chevron-down.svg
// module id = 402
// module chunks = 0